import React from "react";
import { Reveal, SectionHeader } from "./Reveal";
import { FAQ } from "../../lib/content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

export const Faq = ({ items, overline = "FAQ", title = "Frequently asked questions." }) => {
  const list = items || FAQ;
  return (
  <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-[#0A0A0A] border-y border-white/5">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <SectionHeader overline={overline} title={title} />
      <div className="max-w-3xl mt-12">
        <Accordion type="single" collapsible className="w-full">
          {list.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-white/10"
            >
              <AccordionTrigger className="text-left font-display text-base md:text-lg font-semibold text-white hover:text-silver hover:no-underline py-6">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-gray-400 font-light text-base leading-relaxed pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
  );
};
